import React, { useState, useEffect, useRef } from 'react';

import { motion } from "framer-motion";

// import NaverLogin from 'react-naver-login';
// import KakaoLogin from "react-kakao-login";

import { toast } from 'react-toastify';

import { useLang, usePopup, useUser } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import { emailMasking, regPhone, regEmail, regPassword, regNick, errorMessage } from "../utils/utils";
import * as APIS from "../utils/service";

import Image from './Image';
import Input from './Input';
import Button from './Button';
import ContainerLoader from './ContainerLoader';
import SignUp from './SignUp';
import SnsLogin from './SnsLogin';

import images from '../libs/images';
import consts from '../libs/consts';
import routes from '../libs/routes';

export default function SignIn({
    setPage,
    processIndex,
    setProcessIndex
}) {

    const ref = useRef(null);
    const hpref = useRef();
    const emailref = useRef();
    const pwref = useRef();
    const repwref = useRef();
    const nickref = useRef();

    const { signPop, openSignTermPop, closeSignPop } = usePopup();
    const { user, token, login } = useUser();
    const { country, getLang } = useLang();

    const [hp, sethp] = useState('');
    const [num, setnum] = useState('');
    const [timer, setTimer] = useState(false);
    const [timerView, setTimerView] = useState(false);

    const [email, setemail] = useState('');
    const [pw, setpw] = useState('');
    const [repw, setrepw] = useState('');
    const [nickname, setnickname] = useState('');
    const [row, setrow] = useState("");

    const [chkarr, setchkarr] = useState([]);
    const [error, setError] = useState({});

    const [process, setprocess] = useState(1);
    const [step, setstep] = useState(1);

    const [load, setLoad] = useState(false);

    useEffect(() => {
        setprocess(processIndex)
    }, [processIndex])

    useEffect(() => {
        if (setProcessIndex) setProcessIndex(process)
    }, [process])

    useEffect(() => {

        if (step === 2) {
            setnum('');
        }

    }, [step])

    useEffect(() => {

        console.log('chkarr', chkarr);

    }, [chkarr])

    const timeOut = () => {

        console.log("타임 아웃입니다");
        setError({ ...error, findNum: <LangText id={'error_invalid_auth_time'} /> })
        setTimer(false);
        setstep(1);
    }

    const handleKeyDown = (e) => {
        if (e?.key === 'Enter') {

            if (process === 3 && step === 1) submitFunc()
            else if (process === 3 && step === 2) checkFunc()
            else if (process === 4) signFunc()
        }
    };

    const termCheckFunc = () => {

        if (chkarr?.filter(x => x < 4)?.length < 3) {
            errorMessage({ msgkey: 'info_policy_required_check' });
            return;
        }

        setprocess(3);
        setTimeout(() => {
            hpref?.current?.focus();
        }, 100)

    }

    const submitFunc = () => {

        if (!regPhone.test(hp)) {
            setError({ ...error, findHp: <LangText id={'error_reg_hp'} /> })
            return;
        }

        if (error?.findHp) return;

        let sender = {
            hp: hp
        }

        APIS.post('/registe/auth', sender).then(({ data }) => {
            console.log('data', data);
            /** 인증번호 발송 했으면 */
            setTimer(true);
            setTimerView(true);
            setstep(2);

            setTimeout(() => {
                ref?.current?.focus();
            }, 100)
            /******************************/
        }).catch((e) => {
            console.log(e?.response);
            setError({ ...error, findHp: <LangText id={e?.response?.data?.msgkey} /> })
            return;
        });

    }

    const checkFunc = () => {

        if (num?.length < 6) {
            setError({ ...error, findNum: <LangText id={'error_invalid_null_auth'} /> })
            return;
        }

        let sender = {
            hp: hp,
            authNumber: num
        }
        APIS.post('/registe/authCheck', sender).then(({ data }) => {
            console.log('data', data);
            setprocess(4);
            setTimeout(() => {
                emailref?.current?.focus();
            }, 100)
        }).catch(({ response }) => {
            // errorMessage(response?.data);
            let data = response?.data?.data;

            if (data) {
                setrow({
                    ...data,
                    msg:
                        data?.type === 'email' ?
                            getLang({ key: 'info_user_id' })
                            :
                            getLang({ key: 'info_user_id_text', replace: { key: '{0}', val: `<span>${getLang({ key: data?.type === 'kakao' ? 'text_kakao_easysign' : 'text_naver_easysign' })}</span>` } })
                });

                setstep(3);
                setTimer(false);
            } else {
                setError({ ...error, findNum: <LangText id={response?.data?.msgkey} /> })
            }

        });
    }

    const signFunc = () => {

        if (load) return;

        if (!regEmail.test(email)) {
            setError({ ...error, signEmail: <LangText id={'error_reg_email'} /> });
            emailref?.current?.focus();
            return;
        }

        if (!regPassword.test(pw)) {
            setError({ ...error, signPw: <LangText id={'error_reg_pass'} /> })
            pwref?.current?.focus();
            return;
        }

        if (pw !== repw) {
            setError({ ...error, signRePw: <LangText id={'error_match_pass'} /> })
            repwref?.current?.focus();
            return;
        }

        if (!regNick.test(nickname)) {
            setError({ ...error, signNick: <LangText id={'error_reg_nickname'} /> })
            nickref?.current?.focus();
            return;
        }

        setLoad(true);

        let sender = {
            email: email,
            pass: pw,
            name: nickname,
            hp: hp,
            marketing: Boolean(chkarr?.find(x => x === 4))
        }

        APIS.post('/registe', sender).then(({ data }) => {
            console.log('data', data);
            toast.success(<LangText id={'text_registe_success'} />);
            setPage('');
        }).catch(({ response }) => {
            console.log(response?.data);
            // errorMessage(response?.data);
            if (response?.data?.input) {
                setError({ ...error, [response?.data?.input]: <LangText id={response?.data?.msgkey} /> })
            } else {
                errorMessage(response?.data);
            }

        }).finally(() => {
            setTimeout(() => {
                setLoad(false);
            }, 100)
        });

    }


    const allchk = (v) => {
        setchkarr(v ? [1, 2, 3, 4] : []);

        console.log("is1", chkarr?.find(item => item === 1))
        console.log("is2", chkarr?.find(item => item === 2))
        console.log("is3", chkarr?.find(item => item === 3))
        console.log("is4", chkarr?.find(item => item === 4))
    }

    const onechk = (idx) => {

        if (chkarr?.includes(idx)) {
            setchkarr(chkarr?.filter(item => item != idx));
        } else {
            setchkarr([...chkarr, idx]);
        }
    }

    const linkFunc = (type = 1) => {
        openSignTermPop(type);
    }

    useEffect(() => {
        console.log("process", process)
    }, [process])

    return (


        <div
            className="login_root"
        >
            <ContainerLoader load={load} />

            <div className='img' />

            <p className='title'>
                <LangText id={process === 1 ? 'text_registe' : 'text_registe_email'} />
            </p>

            {process === 1 ? (
                <div className='find_btns'>
                    <Button title={<LangText id={'btn_registe_email'} />} onClick={() => setprocess(2)} />
                    <SnsLogin type={'kakao'} />
                    <SnsLogin type={'naver'} />
                </div>
            ) : process === 2 ? (
                <div className='term_box'>
                    <p className='title'>
                        <LangText id={'info_policy_check'} />
                    </p>
                    <ul className='term_list'>
                        <li>
                            <input type="checkbox" id={"checkall"} className='checkbox' checked={chkarr?.length === 4} onChange={(e) => allchk(e.target.checked)} />
                            <label for={'checkall'}>
                                <LangText id={'info_policy_all'} />
                            </label>
                        </li>

                        <li>
                            <input type="checkbox" id={"check1"} className='checkbox' checked={chkarr.includes(1)} onChange={(e) => onechk(1)} />
                            <label for={'check1'}>
                                <LangText id={'info_policy_14'} /> (<LangText id={'text_require'} />)
                            </label>

                        </li>
                        <li>
                            <input type="checkbox" id={"check2"} className='checkbox' checked={chkarr.includes(2)} onChange={(e) => onechk(2)} />
                            <label for={'check2'}>
                                <LangText id={'info_policy_service'} /> (<LangText id={'text_require'} />)
                            </label>
                            <button className='term_link_btn' onClick={() => linkFunc(1)} />
                        </li>
                        <li>
                            <input type="checkbox" id={"check3"} className='checkbox' checked={chkarr.includes(3)} onChange={(e) => onechk(3)} />
                            <label for={'check3'}>
                                <LangText id={'info_policy_private'} /> (<LangText id={'text_require'} />)
                            </label>
                            <button className='term_link_btn' onClick={() => linkFunc(2)} />
                        </li>
                        <li>
                            <input type="checkbox" id={"check4"} className='checkbox' checked={chkarr.includes(4)} onChange={(e) => onechk(4)} />
                            <label for={'check4'}>
                                <LangText id={'info_policy_maketing'} /> (<LangText id={'text_select'} />)
                            </label>
                            <button className='term_link_btn' onClick={() => linkFunc(3)} />
                        </li>

                    </ul>

                    <Button title={<LangText id={'btn_next'} />} onClick={termCheckFunc} />

                </div>
            ) : process === 3 ? (
                <>
                    {step < 3 && <p className='sub_title'>
                        <LangText id={'info_policy_hp'} />
                    </p>}
                    <div className='find_form'>
                        <Input
                            refs={hpref}
                            type="tel"
                            name="findHp"
                            value={hp}
                            setValue={sethp}
                            onKeyDown={handleKeyDown}
                            label={<LangText id={'text_hp'} />}
                            error={error}
                            setError={setError}
                            disabled={timer || step === 3}
                        />
                        {(step < 3 && timerView) && (
                            <Input
                                refs={ref}
                                type="tel"
                                name="findNum"
                                value={num}
                                setValue={setnum}
                                onKeyDown={handleKeyDown}
                                label={<LangText id={'text_authnum'} />}
                                error={error}
                                setError={setError}
                                maxlength={6}
                                timer={timer}
                                timerState={timeOut}
                                readOnly={!timer}
                            />
                        )}

                        {step === 3 && (
                            <div className='find_result_box'>
                                <p className="title" dangerouslySetInnerHTML={{ __html: row?.msg }}></p>
                                {row?.type !== 'email' && <p className="title"><LangText id={'info_social_login'} /></p>}
                                <p className='email'>{row?.email}</p>
                            </div>
                        )}

                    </div>

                    <div className='find_btns'>
                        {step === 1 ? (
                            <Button title={<LangText id={'btn_get_auth'} />} onClick={submitFunc} />
                        ) : step === 2 ? (
                            <Button title={<LangText id={'btn_check_auth'} />} onClick={checkFunc} />
                        ) : step === 3 ? (
                            row?.type === 'email' ?
                                <Button title={<LangText id={'btn_login'} />} onClick={() => setPage('')} />
                                :
                                <SnsLogin type={row?.type} />
                        ) : (
                            <></>
                        )}

                    </div>
                </>
            ) : process === 4 ? (
                <>
                    <p className='sub_title'>
                        <LangText id={'info_policy_hp'} />
                    </p>
                    <div className='find_form'>
                        <Input
                            refs={emailref}
                            name="signEmail"
                            value={email}
                            setValue={setemail}
                            onKeyDown={handleKeyDown}
                            label={<LangText id={'text_email'} />}
                            error={error}
                            setError={setError}
                        />
                        <div className='new_pw_box'>
                            <Input
                                refs={pwref}
                                type="password"
                                name="signPw"
                                placeholder={getLang({ key: 'placeholder_pass' })}
                                value={pw}
                                setValue={setpw}
                                onKeyDown={handleKeyDown}
                                label={<LangText id={'text_pass'} />}
                                error={error}
                                setError={setError}
                            />
                            <Input
                                refs={repwref}
                                type="password"
                                name="signRePw"
                                placeholder={getLang({ key: 'placeholder_pass_re' })}
                                value={repw}
                                setValue={setrepw}
                                onKeyDown={handleKeyDown}
                                error={error}
                                setError={setError}
                            />
                        </div>
                        <Input
                            refs={nickref}
                            name="signNick"
                            placeholder={getLang({ key: 'placeholder_nickname' })}
                            value={nickname}
                            setValue={setnickname}
                            onKeyDown={handleKeyDown}
                            label={<LangText id={'text_nickname'} />}
                            error={error}
                            setError={setError}
                        />
                    </div>

                    <div className='find_btns'>
                        <Button title={<LangText id={'btn_registe_confirm'} />} onClick={signFunc} />
                    </div>
                </>
            ) : (
                <></>
            )}




        </div>

    )
}